import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentMagentoClient } from "@jti/magento";

const fetchOrderDeliveryLimitsDeclaration = (isFreeTrial: boolean) =>
  createAsyncThunk(
    isFreeTrial ? "freeTrialCheckout/fetchOrderDeliveryLimits" : "checkout/fetchOrderDeliveryLimits",
    async () => getCurrentMagentoClient(isFreeTrial).getOrderDeliveryLimits()
  );

export const fetchOrderDeliveryLimits = fetchOrderDeliveryLimitsDeclaration(false);
export const fetchFreeTrialOrderDeliveryLimits = fetchOrderDeliveryLimitsDeclaration(true);
